import React, { useEffect, useState } from 'react';
import { useFirestore } from 'react-redux-firebase';

function QuestionStatus(props) {
  const { profile } = props;
  const firestore = useFirestore();
  const [haveQuestions, setHaveQuestions] = useState(true);

  useEffect(() => {
    if (profile && profile.id) {
      try {
        firestore
          .collection('userTrivia')
          .doc(profile.id)
          .get()
          .then((doc) => {
            if (doc.exists) {
              const { triviaQuestions } = doc.data();
              if (triviaQuestions && triviaQuestions.length > 0) {
                const type1 = triviaQuestions.filter((q) => q.type === '1');
                const type2 = triviaQuestions.filter((q) => q.type === '2');
                const type3 = triviaQuestions.filter((q) => q.type === '3');
                const type4 = triviaQuestions.filter((q) => q.type === '4');
                const type5 = triviaQuestions.filter((q) => q.type === '5');
                if (
                  type1.length === 0 ||
                  type2.length === 0 ||
                  type3.length === 0 ||
                  type4.length === 0 ||
                  type5.length === 0
                ) {
                  setHaveQuestions(false);
                }
              }
            }
          })
          .catch((e) => {
            console.log(e.message);
          });
      } catch (e) {
        console.log(e.message);
      }
    }
  }, [firestore, profile]);

  return (
    <div>
      {haveQuestions ? (
        <div>
          <span className="green white-text">Have Questions</span>
        </div>
      ) : (
        <div>
          <span className="red white-text">Not Questions</span>
        </div>
      )}
    </div>
  );
}

export default QuestionStatus;
